import { render, staticRenderFns } from "./PaymentCardknoxPoS.vue?vue&type=template&id=1568c20b&"
import script from "./PaymentCardknoxPoS.vue?vue&type=script&lang=js&"
export * from "./PaymentCardknoxPoS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports